module.exports = __webpack_public_path__ + "img/full1.f85e2388.png";